// Shared keydown guard (U2). Global hotkeys — Space (play/pause), D (hide HUD),
// W/E (gizmo mode), ,/. (morph scrub), ⌘Z (undo) — must bail when the keystroke
// belongs to a focused control: text inputs, textareas, native <select>
// dropdowns (which KEEP focus after a choice, so the next Space toggled the
// clock and blocked the dropdown), or contentEditable. Previously the guards
// exempted only INPUT/TEXTAREA, so a focused era/channel dropdown leaked keys.
export function isTextEntryTarget(e: { target: EventTarget | null }): boolean {
  const t = e.target;
  return (
    t instanceof HTMLInputElement ||
    t instanceof HTMLTextAreaElement ||
    t instanceof HTMLSelectElement ||
    (t instanceof HTMLElement && t.isContentEditable)
  );
}
